import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid } from 'recharts';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BalanceHistoryChart = ({ token, refreshKey }) => {
  const [days, setDays] = useState(null);

  useEffect(() => {
    axios.get(`${API}/pas-admin/wallet-alerts/history`, { params: { days: 90 }, headers: { Authorization: `Bearer ${token}` } })
      .then(r => setDays(r.data.days)).catch(() => setDays([]));
  }, [token, refreshKey]);

  if (!days) return null;
  return (
    <div className="rounded-lg border border-slate-700 bg-slate-900/50 p-4" data-testid="balance-history-chart">
      <p className="text-sm text-slate-300 font-medium mb-3">Mainnet ETH balance · last 90 days (daily)</p>
      {days.length < 2 ? (
        <p className="text-xs text-slate-500 py-6 text-center" data-testid="balance-history-empty">
          History is being collected: one point is saved per day by the hourly check ({days.length} so far).
        </p>
      ) : (
        <ResponsiveContainer width="100%" height={220}>
          <LineChart data={days} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid stroke="#1e293b" />
            <XAxis dataKey="day" tick={{ fill: '#94a3b8', fontSize: 11 }} />
            <YAxis tick={{ fill: '#94a3b8', fontSize: 11 }} width={60} />
            <Tooltip contentStyle={{ background: '#0f172a', border: '1px solid #334155' }} formatter={(v) => `${Number(v).toFixed(6)} ETH`} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Line type="monotone" dataKey="deployer_eth" name="Deployment wallet" stroke="#a78bfa" dot={false} strokeWidth={2} />
            <Line type="monotone" dataKey="funding_eth" name="Gas funding wallet" stroke="#34d399" dot={false} strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default BalanceHistoryChart;
